var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSquareDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 413,
    height: 413,
    viewBox: "0 0 413 413",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.476 389.98L210.376 399.879C221.336 388.919 251.034 352.857 227.7 301.238L227.673 301.178C207.971 257.635 173.837 224.277 153.1 204.011C150.272 201.182 147.443 201.182 144.615 204.011L83.8036 264.822C80.2681 268.357 78.1467 267.65 75.3183 264.822L18.0427 207.546C15.2142 204.718 15.2142 201.889 18.0427 199.061L199.062 18.0416C201.89 15.2132 204.719 15.2132 207.547 18.0416L264.823 75.3173C267.651 78.1457 268.359 80.267 264.823 83.8026L204.012 144.614C201.183 147.442 201.183 150.271 204.012 153.099C224.287 173.846 257.667 208.002 301.239 227.699C352.858 251.033 388.92 221.335 399.88 210.375L389.981 200.475C389.78 200.676 389.557 200.902 389.314 201.149C382.283 208.28 357.493 233.423 307.603 214.971C281.425 205.289 239.131 167.005 219.568 147.442L274.015 92.9949C283.915 83.0955 283.915 74.6102 274.015 64.7107L217.447 8.14214C207.547 -1.75736 199.062 -1.75736 189.163 8.14214L8.14318 189.162C-1.75632 199.061 -1.75632 207.546 8.14318 217.446L64.7117 274.014C74.6112 283.914 83.0965 283.914 92.996 274.014L148.15 218.86C167.714 238.423 205.997 280.717 215.679 306.895C234.134 356.79 208.322 382.241 201.15 389.313C200.902 389.557 200.677 389.779 200.476 389.98Z",
    fill: "url(#paint0_linear_1_21830)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M338.362 148.856C335.534 146.028 332.705 146.028 329.877 148.856L278.258 200.475L268.359 190.576L319.977 138.957C329.877 129.057 338.362 129.057 348.262 138.957L404.83 195.525C414.73 205.425 414.73 213.91 404.83 223.81L223.811 404.829C213.911 414.729 205.426 414.729 195.527 404.829L138.958 348.26C129.058 338.361 129.058 329.876 138.958 319.976L191.284 267.65L201.183 277.55L148.857 329.876C146.029 332.704 146.029 335.533 148.857 338.361L206.133 395.637C208.962 398.465 211.083 399.172 214.618 395.637L395.638 214.617C399.173 211.082 398.466 208.96 395.638 206.132L338.362 148.856Z",
    fill: "url(#paint1_linear_1_21830)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_21830",
    x1: 98.6529,
    y1: 98.6519,
    x2: 314.32,
    y2: 314.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68C3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#743DD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_21830",
    x1: 98.6529,
    y1: 98.6519,
    x2: 314.32,
    y2: 314.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68C3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#743DD7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSquareDark);
export default __webpack_public_path__ + "static/media/logo-square-dark.8ee10d97de38f407498fc3bcf5f3efaf.svg";
export { ForwardRef as ReactComponent };